import { Injectable } from "@angular/core";
import { BrowserAuthOptions, createNestablePublicClientApplication, IPublicClientApplication } from "@azure/msal-browser";
import { ConfigurationService } from "./configuration.service";

@Injectable({
  providedIn: "root"
})
export class MsalService {
  private msalInstance: IPublicClientApplication = null;
  private msalInstancePromise: Promise<IPublicClientApplication>;

  constructor(private readonly configService: ConfigurationService) {
    this.msalInstancePromise = this.createMsalInstance();
  }

  private async createMsalInstance(): Promise<IPublicClientApplication> {

    const authOptions: BrowserAuthOptions = {
      clientId: this.configService.config.azureClientId,
      authority: "https://login.microsoftonline.com/common",
      clientCapabilities: ["cp1"] // To indicate support for claims challenge
    };

    if (!this.msalInstance) {
      this.msalInstance = await createNestablePublicClientApplication({
        auth: authOptions
      });
    }

    return this.msalInstance;
  }

  getInstance(): Promise<IPublicClientApplication> {
    return this.msalInstancePromise;
  }
}
